import { useState } from 'react';
import { ToggleButton, ToggleButtonGroup } from '@mui/material';

export let units = (() => {
  try {
    return localStorage.getItem('units') || 'imperial';
  } catch (e) {
    return 'imperial';
  }
})();

export const getUnits = () => units;

export const setUnits = (newUnits) => {
  units = newUnits === 'metric' ? 'metric' : 'imperial';
  try {
    localStorage.setItem('units', units);
  } catch (e) {}
};

// Formatting helpers (source data is in ft, mph, °F)
export function formatDistanceFeet(value) {
  if (value == null || Number.isNaN(value)) return '';
  if (units === 'metric') {
    const meters = value * 0.3048;
    return `${Math.round(meters)} m`;
  }
  return `${Math.round(value)} ft`;
}

export function formatAltitudeFeet(value) {
  return formatDistanceFeet(value);
}

export function formatSpeedMph(value) {
  if (value == null || Number.isNaN(value)) return '';
  if (units === 'metric') {
    const kmh = value * 1.60934;
    return `${Math.round(kmh)} km/h`;
  }
  return `${Math.round(value)} mph`;
}

export function formatTemperatureF(value, fractionDigits = 0) {
  if (value == null || Number.isNaN(value)) return '';
  if (units === 'metric') {
    const c = (value - 32) * (5 / 9);
    return `${Number(c.toFixed(fractionDigits))}° C`;
  }
  return `${Number(value.toFixed(fractionDigits))}° F`;
}

// Reusable units selector component
export const UnitsSelector = ({ value, onChange, fixed = true }) => {
  const initial = value || getUnits();
  const [selected, setSelected] = useState(initial);

  const handleChange = (event, newValue) => {
    if (!newValue) return;
    setSelected(newValue);
    setUnits(newValue);
    if (onChange) onChange(newValue);
  };

  const wrapperStyle = fixed
    ? { position: 'fixed', top: 55, left: 1725, zIndex: 2000, background: 'rgba(255,255,255,0.95)', borderRadius: 8, boxShadow: '0 2px 8px rgba(0,0,0,0.15)', padding: 4 }
    : undefined;

  return (
    <div style={wrapperStyle}>
      <ToggleButtonGroup
        size="small"
        value={value !== undefined ? value : selected}
        exclusive
        onChange={handleChange}
        aria-label="Units selector"
      >
        <ToggleButton value="imperial" aria-label="Imperial">°F mph</ToggleButton>
        <ToggleButton value="metric" aria-label="Metric">°C kmh</ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};


